import { Box } from "@mui/material";
import ProfileTop from "./ProfileTop";
import ProfileControls from "./ProfileControls";
import useResponsive from "../../hooks/useResponsive";
import { UserDataPropsType } from "../../interface/users";

const ProfileContent = ({ user_info }: { user_info: UserDataPropsType }) => {
  const isMedium = useResponsive("down", "md", "xs");

  return (
    <Box
      sx={{
        padding: isMedium ? 3 : 4,
      }}
    >
      <ProfileTop user_info={user_info} />
      <ProfileControls />
    </Box>
  );
};

export default ProfileContent;
